import { resetDataLayerAndPushEvent } from '..';
import { CustomEventName } from '@/constants';

export const gtmViewJoinUsReports = () => {
  resetDataLayerAndPushEvent(CustomEventName.ViewJoinUsReports);
};
